module.exports = __webpack_public_path__ + "img/weatherpedia-pwa4.528f35dd.jpeg";